import React from "react";
import TrashIcon from "../../icons/trashIcon";
import Dialog from "../dialog";
import Button from "../button";
import styles from "./style.module.css";

const DeleteModal = ({ open, onClose, onDelete, title, description }) => {
  const handleClose = () => {
    onClose();
  };
  const handleDelete = () => {
    onDelete && onDelete();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="450px">
      <div className={styles.delete_modal}>
        <div className={styles.delete_modal_icon}>
          <div className={styles.delete_modal_icon_inner}>
            <TrashIcon />
          </div>
        </div>
        <div className={styles.delete_modal_title}>{title}</div>
        <div className={styles.delete_modal_content}>
          {description}
        </div>
        <div className={styles.delete_modal_actions}>
          <Button
            customClass={styles.dma_btn}
            buttonType="outlined"
            title="Cancel"
            onClick={handleClose}
          />
          <Button
            customClass={styles.dma_btn}
            title="Delete"
            onClick={handleDelete}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteModal;
